import React, { useEffect, useState, createElement } from 'react';
import { Calendar, Clock, Lock, Mail, MessageCircle, Download, Video, CheckCircle2, HelpCircle, Sparkles, Gift } from 'lucide-react';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
const getNextThursdayDay = () => {
  const now = new Date();
  const estTime = new Date(now.toLocaleString('en-US', {
    timeZone: 'America/New_York'
  }));
  const currentDay = estTime.getDay();
  const currentHour = estTime.getHours();
  let daysUntilThursday = 0;
  if (currentDay === 4) {
    daysUntilThursday = currentHour >= 18 ? 7 : 0;
  } else if (currentDay < 4) {
    daysUntilThursday = 4 - currentDay;
  } else {
    daysUntilThursday = 7 - currentDay + 4;
  }
  const next = new Date(estTime);
  next.setDate(estTime.getDate() + daysUntilThursday);
  return next.getDate();
};
const getThursdayLabel = () => {
  const now = new Date();
  const estTime = new Date(now.toLocaleString('en-US', {
    timeZone: 'America/New_York'
  }));
  const currentDay = estTime.getDay();
  const currentHour = estTime.getHours();
  let daysUntilThursday = 0;
  if (currentDay === 4) {
    daysUntilThursday = currentHour >= 19 ? 7 : 0;
  } else if (currentDay < 4) {
    daysUntilThursday = 4 - currentDay;
  } else {
    daysUntilThursday = 7 - currentDay + 4;
  }
  const next = new Date(estTime);
  next.setDate(estTime.getDate() + daysUntilThursday);
  const day = next.getDate();
  const month = next.toLocaleString('es-ES', {
    month: 'long'
  }).toUpperCase();
  return `JUEVES ${day} DE ${month}`;
};
const BREAKOUT_VIDEOS = [{
  id: '1173156247',
  title: '¿Y si HEYLLOYD no funciona para mi nicho o tipo de negocio?'
}, {
  id: '1173156261',
  title: 'Ya he invertido en otros programas y no me funcionaron. ¿Qué hace a este diferente?'
}, {
  id: '1173156277',
  title: 'No tengo tiempo para implementar otro sistema complejo.'
}, {
  id: '1173156217',
  title: 'Me preocupa el costo de la inversión. ¿Cuál es el ROI real?'
}, {
  id: '1173156206',
  title: '¿No puedo simplemente hacer lo mismo con ChatGPT y otras herramientas gratuitas?'
}];
export function ThankYouDealershipPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'ThankYou-Dealership-View');
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/nrxtdp5ht5.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='nrxtdp5ht5']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/nrxtdp5ht5/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top:56.25%; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      try {
        document.head.removeChild(playerScript);
        document.head.removeChild(embedScript);
        document.head.removeChild(style);
      } catch (e) {
        // noop
      }
    };
  }, []);
  const thursdayLabel = getThursdayLabel();
  const thursdayDay = getNextThursdayDay();
  return <div className="min-h-screen bg-[#0a1428] text-white font-sans selection:bg-amber-400 selection:text-[#0a1428] overflow-x-hidden" data-id="element-3758">
      <noscript data-id="element-3759">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-3760" />
      </noscript>

      {/* Background image layer */}
      <div className="absolute top-0 left-0 w-full h-[400px] md:h-[600px] z-0 opacity-60 pointer-events-none" data-id="element-3761">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="Background Pattern" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-3762" />
      </div>

      {/* Ambient glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-amber-500/[0.08] blur-[140px] rounded-full pointer-events-none" data-id="element-3763" />
      <div className="absolute top-[40%] right-0 w-[500px] h-[500px] bg-amber-400/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-3764" />
      <div className="absolute top-[10%] left-0 w-[400px] h-[400px] bg-blue-500/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-3765" />

      <div className="absolute inset-0 opacity-[0.015] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-3766" />

      {/* Date confirmation banner */}
      <div className="relative z-20 bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 text-[#0a1428] py-3 md:py-4 px-4 shadow-lg" data-id="element-3767">
        <div className="max-w-5xl mx-auto flex items-center justify-center gap-2 md:gap-3 text-center" data-id="element-3768">
          <Calendar className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" data-id="element-3769" />
          <p className="text-xs sm:text-sm md:text-base font-black uppercase tracking-tight whitespace-nowrap" data-id="element-3770">
            Reservada La Fecha: Jueves {thursdayDay} | 7PM EST (Hora Miami)
          </p>
        </div>
      </div>

      <main className="relative z-10 max-w-6xl mx-auto px-4 lg:px-8 pt-10 md:pt-14 lg:pt-16 pb-12" data-id="element-3771">
        {/* Hero */}
        <section className="text-center mb-10 md:mb-14" data-id="element-3772">
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-4 py-1.5 mb-5 md:mb-6" data-id="element-3773">
            <Lock className="w-3.5 h-3.5 text-emerald-400" data-id="element-3774" />
            <span className="text-emerald-400 text-[11px] md:text-sm font-black uppercase tracking-[0.18em] leading-none" data-id="element-3775">
              Tu Lugar Está Confirmado
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tight mb-4 md:mb-5 max-w-4xl mx-auto" data-id="element-3776">
            Completa Estos{' '}
            <span className="relative inline-block" data-id="element-3777">
              <span className="relative z-10 text-amber-400" data-id="element-3778">3 Pasos</span>
              <span className="absolute bottom-1 left-0 w-full h-3 bg-amber-400/15 -z-0 rounded-sm" data-id="element-3779" />
            </span>{' '}
            Importantes Antes De Que Te Vayas
          </h1>

          <p className="text-base md:text-lg lg:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-3780">
            Para aprovechar al máximo la masterclass.
          </p>
        </section>

        {/* Video + WhatsApp side by side */}
        <section className="grid grid-cols-1 lg:grid-cols-5 gap-5 md:gap-6 mb-12 md:mb-16" data-id="element-3781">
          {/* Video — 3 cols */}
          <div className="lg:col-span-3" data-id="element-3782">
            <div className="relative bg-[#0f1b35] border border-amber-500/30 rounded-2xl overflow-hidden shadow-[0_0_50px_rgba(245,158,11,0.15)]" data-id="element-3783">
              <wistia-player media-id="nrxtdp5ht5" aspect="1.7777777777777777" data-id="element-3784"></wistia-player>
            </div>
          </div>

          {/* WhatsApp Step 1 — 2 cols */}
          <div className="lg:col-span-2" data-id="element-3785">
            <div className="h-full bg-gradient-to-br from-[#25D366]/15 to-[#128C7E]/10 border-2 border-[#25D366]/50 rounded-2xl p-5 md:p-6 flex flex-col" data-id="element-3786">
              <div className="inline-flex items-center gap-2 bg-[#25D366] rounded-full px-3.5 py-1.5 self-start mb-4" data-id="element-3787">
                <MessageCircle className="w-4 h-4 text-white" data-id="element-3788" />
                <span className="text-white text-[11px] md:text-xs font-black uppercase tracking-wider" data-id="element-3789">
                  Paso #1 · Únete Al Grupo
                </span>
              </div>

              <p className="text-gray-200 text-sm md:text-base leading-relaxed mb-5 flex-1" data-id="element-3790">
                <span className="text-[#25D366] font-bold" data-id="element-3791">¡IMPORTANTE!</span>{' '}
                Únete ahora al grupo exclusivo de WhatsApp para recibir
                recordatorios y contenido extra antes del jueves.
              </p>

              <a href="https://chat.whatsapp.com/B6i9fK1WMD05vaRZ6t9gvF" target="_blank" rel="noopener noreferrer" className="group w-full bg-[#25D366] hover:bg-[#1fb854] text-white font-black text-sm md:text-base uppercase tracking-tight rounded-xl py-4 px-5 flex items-center justify-center gap-2.5 shadow-[0_10px_30px_-10px_rgba(37,211,102,0.5)] transition-all duration-300 hover:scale-[1.02]" data-id="element-3792">
                <MessageCircle className="w-5 h-5" data-id="element-3793" />
                Unirme Al Grupo
              </a>
            </div>
          </div>
        </section>

        {/* Step 2 — Regalo Exclusivo */}
        <section className="mb-12 md:mb-16 max-w-4xl mx-auto" data-id="element-3794">
          <div className="text-center mb-6 md:mb-8" data-id="element-3795">
            <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-4" data-id="element-3796">
              <Gift className="w-3.5 h-3.5 text-amber-400" data-id="element-3797" />
              <span className="text-amber-400 text-[11px] md:text-xs font-black uppercase tracking-[0.18em] leading-none" data-id="element-3798">
                Paso #2 · Regalo Exclusivo
              </span>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black leading-tight mb-3" data-id="element-3799">
              Descarga La Guía{' '}
              <span className="text-amber-400" data-id="element-3800">"Escapa del Dealership"</span>
            </h2>
            <p className="text-gray-400 text-sm md:text-base" data-id="element-3801">
              Haz clic en la imagen para descargar la guía
            </p>
          </div>

          <a href="https://drive.google.com/file/d/1UwCS-6hTXssQIqMUObPKvMnumSsTNm5u/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="block group relative mb-8" data-id="element-3802">
            <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/30 to-amber-400/30 rounded-2xl blur-md opacity-0 group-hover:opacity-100 transition duration-500" data-id="element-3803" />
            <div className="relative" data-id="element-3804">
              <img src="https://cdn.magicpatterns.com/uploads/qGszUSvXKGkMXKzhkKHKP9/heylloyd-image-1769473134106.png" alt="Regalo Gratis — Guía Completa de Implementación" className="w-full h-auto rounded-2xl border border-amber-500/30 group-hover:border-amber-400 group-hover:scale-[1.01] transition-all duration-300 cursor-pointer shadow-2xl" data-id="element-3805" />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/20 rounded-2xl" data-id="element-3806">
                <div className="bg-amber-400 text-[#0a1428] px-6 py-3 rounded-full font-black text-base shadow-2xl flex items-center gap-2" data-id="element-3807">
                  <Download className="w-5 h-5" data-id="element-3808" />
                  Descargar Guía
                </div>
              </div>
            </div>
          </a>

          <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-5 md:p-8 text-gray-300 text-sm md:text-base lg:text-[17px] leading-relaxed space-y-4" data-id="element-3809">
            <p data-id="element-3810">
              Antes del workshop, quiero que descargues esta guía y la leas con
              calma.
            </p>
            <p data-id="element-3811">
              Esta guía no es un regalo más. No es un PDF para ejecutar. Y no es
              algo para "aplicar" todavía.
            </p>
            <p data-id="element-3812">
              Su único objetivo es ayudarte a llegar al workshop con el{' '}
              <span className="text-white font-semibold" data-id="element-3813">
                marco mental correcto
              </span>
              .
            </p>
            <p data-id="element-3814">
              La mayoría de las personas se equivoca antes de empezar — no
              porque no sepa qué hacer, sino porque empieza por el lugar
              incorrecto.
            </p>
            <p className="text-white font-semibold" data-id="element-3815">
              Esta guía te ayudará a entender el orden correcto para que el
              contenido del workshop tenga sentido desde el primer minuto.
            </p>
          </div>
        </section>

        {/* Step 3 — Revisa Tu Email */}
        <section className="mb-14 md:mb-20 max-w-4xl mx-auto" data-id="element-3816">
          <div className="bg-gradient-to-br from-[#0f1b35] to-[#0a1428] border border-amber-500/20 rounded-2xl p-5 md:p-7 flex items-start md:items-center gap-4 md:gap-5" data-id="element-3817">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-3818">
              <Mail className="w-5 h-5 md:w-6 md:h-6 text-amber-400" data-id="element-3819" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-3820">
              <div className="text-amber-400 text-[10px] md:text-xs font-black uppercase tracking-[0.18em] mb-1.5" data-id="element-3821">
                Paso #3
              </div>
              <h3 className="text-lg md:text-2xl font-black text-white mb-1.5 leading-tight" data-id="element-3822">
                Revisa Tu Email
              </h3>
              <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-3823">
                Revisa tu bandeja de entrada{' '}
                <span className="text-white font-semibold" data-id="element-3824">(y spam)</span> para
                confirmar tu acceso al evento del{' '}
                <span className="text-amber-400 font-bold" data-id="element-3825">
                  {thursdayLabel}
                </span>{' '}
                a las 7PM EST.
              </p>
            </div>
          </div>
        </section>

        {/* Breakout Videos */}
        <section className="mb-12" data-id="element-3826">
          <div className="text-center mb-8 md:mb-10" data-id="element-3827">
            <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-4" data-id="element-3828">
              <HelpCircle className="w-3.5 h-3.5 text-amber-400" data-id="element-3829" />
              <span className="text-amber-400 text-[11px] md:text-xs font-black uppercase tracking-[0.18em] leading-none" data-id="element-3830">
                Preguntas Frecuentes
              </span>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black leading-tight mb-3" data-id="element-3831">
              ¿Tienes Dudas?{' '}
              <span className="text-amber-400" data-id="element-3832">Las Resolvemos Aquí.</span>
            </h2>
            <p className="text-gray-400 text-sm md:text-base max-w-2xl mx-auto" data-id="element-3833">
              Mira estos videos cortos para resolver las preguntas más comunes
              antes del webinar.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-3834">
            {BREAKOUT_VIDEOS.map((v, idx) => <div key={v.id} className="bg-white/[0.025] border border-white/[0.08] hover:border-amber-500/40 rounded-2xl overflow-hidden flex flex-col transition-all duration-300 group" data-id="element-3835">
                <div className="relative bg-[#0f1b35]" data-id="element-3836">
                  <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-3837">
                    <iframe src={`https://player.vimeo.com/video/${v.id}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title={`Breakout video ${idx + 1}`} data-id="element-3838" />
                  </div>
                </div>
                <div className="p-4 md:p-5 flex items-start gap-2.5 flex-1" data-id="element-3839">
                  <div className="w-7 h-7 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-3840">
                    <Video className="w-3.5 h-3.5 text-amber-400" data-id="element-3841" />
                  </div>
                  <p className="text-sm md:text-[15px] text-white font-semibold leading-snug" data-id="element-3842">
                    {v.title}
                  </p>
                </div>
              </div>)}
          </div>
        </section>
      </main>

      <Footer data-id="element-3843" />
    </div>;
}